import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { LoginForm } from "./login-form";
import { OtpForm } from "./otp-form";
import { RegisterForm } from "./register-form";

export default function Authentication({ onClose }: { onClose: any }) {
	const [mode, setMode] = useState<"login" | "register" | "otp">("login");

	const [mobile, setMobile] = useState("");
	const [password, setPassword] = useState("");
	const [username, setUsername] = useState("");
	const [refCode, setRefCode] = useState("");
	const searchParams = useSearchParams();

	useEffect(() => {
		const ref = searchParams.get("referral");
		if (ref) {
			setRefCode(ref);
		}
	}, [searchParams]);

	const handleSwitchMode = (newMode: "login" | "register" | "otp") => {
		setMode(newMode);
	};

	return (
		<div
			id="authentication"
			className="fixed inset-0 bg-black bg-opacity-90 flex flex-col justify-center items-center z-50"
		>
			<button
				type="button"
				className="absolute top-5 right-5 text-white text-3xl"
				onClick={onClose}
			>
				<IoCloseSharp className="w-6 h-6" />
			</button>

			<div className="flex flex-col">
				<div className="w-full">
					<Image
						className="m-auto"
						src="/cutin.svg"
						alt="Cutin"
						width={160}
						height={28}
					/>
				</div>

				<hr className="my-[18px] mx-auto w-[360px]" />

				<div className="flex flex-col items-center justify-center w-[360px]">
					{mode !== "otp" && (
						<div className="flex w-full justify-around mb-12 text-lg font-semibold">
							<button
								type="button"
								onClick={() => handleSwitchMode("login")}
								className={mode === "login" ? "text-pink-500" : "text-gray-600"}
							>
								ورود
							</button>
							<button
								type="button"
								onClick={() => handleSwitchMode("register")}
								className={
									mode === "register" ? "text-pink-500" : "text-gray-600"
								}
							>
								ثبت نام
							</button>
						</div>
					)}

					{mode === "login" && (
						<LoginForm
							mobile={mobile}
							setMobile={setMobile}
							password={password}
							setPassword={setPassword}
							onSwitchMode={handleSwitchMode}
							onClose={onClose}
						/>
					)}

					{mode === "register" && (
						<RegisterForm
							mobile={mobile}
							setMobile={setMobile}
							password={password}
							setPassword={setPassword}
							username={username}
							setUsername={setUsername}
							refCode={refCode}
							setRefCode={setRefCode}
							onSwitchMode={handleSwitchMode}
						/>
					)}

					{mode === "otp" && (
						<OtpForm
							mobile={mobile}
							onSwitchMode={handleSwitchMode}
							onClose={onClose}
						/>
					)}
				</div>
			</div>
		</div>
	);
}
